
// components/QuantityControls.jsx
import React from 'react';

const QuantityControls = ({ item, onQuantityChange }) => {
    const handleDecrease = (e) => {
        e.stopPropagation();
        onQuantityChange(item, Math.max(1, (item.quantity || 1) - 1));
    };

    const handleIncrease = (e) => {
        e.stopPropagation();
        onQuantityChange(item, (item.quantity || 1) + 1);
    };

    return (
        <div className="quantity-wrapper">
            <button className="qty-btn small" onClick={handleDecrease}>
                −
            </button>
            <span className="qty-value">{item.quantity || 1}</span>
            <button className="qty-btn small" onClick={handleIncrease}>
                +
            </button>
        </div>
    );
};

export default QuantityControls;